// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/adozione/monitoraggio',
    requestBody: null,
    response: '{"success":true,"data":{"righe":[{"societaId":1,"societaNome":"Pianinvest","piano":{"id":1,"titolo":"Adozione BOP 2026","dataInizio":"2026-09-10","dataFine":"2026-12-10"},"totale":12,"chiuse":4,"percentuale":33,"obiettiviInRitardo":1,"attivitaInRitardo":2,"feedbackAperti":3,"ultimoMovimento":"2026-09-09T10:00:00.000Z"}],"feedbackAperti":[],"attivitaScadute":[]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/adozione/remind/esegui',
    requestBody: null,
    response: '{"success":true,"data":{"processati":4,"inviati":3,"saltati":1}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
